import { CUSTOM_ELEMENTS_SCHEMA, forwardRef, Injectable, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { Globals } from './_utlity/globals';
import { AppComponent } from './app.component';
import { AppBootstrapModule } from './app-bootstrap.module';
import { AppRoutingModule } from './app-routing.module';
import { ToastrModule } from 'ngx-toastr';
import { CommonModule, APP_BASE_HREF, LocationStrategy, HashLocationStrategy, DatePipe, PathLocationStrategy } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HeaderComponent } from './_shared/layout/header/header.component';
import { FooterComponent } from './_shared/layout/footer/footer.component';
import { InitialComponent } from './_shared/initial/initial.component';
import { MainComponent } from './_shared/main/main.component';
import { LoginComponent } from './auth/login/login.component';
import { ForgotComponent } from './auth/forgot/forgot.component';
import { HomeComponent } from './dashboard/home/home.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { BrowserComComponent } from './common/browser-com/browser-com.component';
import { DownTimeComponent } from './common/down-time/down-time.component';
import { LogoutComponent } from './common/logout/logout.component';
import { ServerErrorComponent } from './common/server-error/server-error.component';
import { SessionExpiredComponent } from './common/session-expired/session-expired.component';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';
import { ProgressBarModule } from 'primeng/progressbar';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { TabViewModule } from 'primeng/tabview';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MenuModule } from 'primeng/menu';
import { AccordionModule } from 'primeng/accordion';
import { ChartModule } from 'primeng/chart';
import { InputSwitchModule } from 'primeng/inputswitch';
import { SidebarModule } from 'primeng/sidebar';
import { ApprovalComponent } from './dashboard/approval/approval.component';
import { QuickDeligationComponent } from './dashboard/quick-deligation/quick-deligation.component';
import { AdvancedDelegationComponent } from './dashboard/advanced-delegation/advanced-delegation.component';
import { DelegationReportsComponent } from './dashboard/delegation-reports/delegation-reports.component';
import { InitiateDelegationComponent } from './dashboard/initiate-delegation/initiate-delegation.component';
import { ConfigureRoleComponent } from './dashboard/configure-role/configure-role.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { CarouselModule } from 'primeng/carousel';
import { OnBehalfDelegationComponent } from './dashboard/on-behalf-delegation/on-behalf-delegation.component';
import { MsalBroadcastService, MsalGuard, MsalInterceptor, MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { PublicClientApplication, BrowserCacheLocation, InteractionType } from '@azure/msal-browser';
import { MessageService } from 'primeng/api';
import { CdsConfigData } from 'src/app/_shared/common/config'
import { RatingModule } from 'ngx-bootstrap/rating';
import { UnAuthorizedComponent } from './auth/un-authorized/un-authorized.component';
import { SafePipeModule } from 'safe-pipe';
import { FileUploadModule } from 'primeng/fileupload';
import { NgxSpinnerModule } from "ngx-spinner";
import { CSP_NONCE } from '@angular/core';


@NgModule({
    declarations: [
        AppComponent,
        DashboardComponent,
        HeaderComponent,
        FooterComponent,
        InitialComponent,
        MainComponent,
        LoginComponent,
        ForgotComponent,
        HomeComponent,
        NotFoundComponent,
        BrowserComComponent,
        DownTimeComponent,
        LogoutComponent,
        ServerErrorComponent,
        SessionExpiredComponent,
        ApprovalComponent,
        QuickDeligationComponent,
        AdvancedDelegationComponent,
        DelegationReportsComponent,
        InitiateDelegationComponent,
        ConfigureRoleComponent,
        OnBehalfDelegationComponent,
        UnAuthorizedComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        AppBootstrapModule,
        //HttpClientModule,
        CheckboxModule,
        DropdownModule,
        AutoCompleteModule,
        InputTextModule,
        CalendarModule,
        InputTextareaModule,
        DialogModule,
        ProgressBarModule,
        TooltipModule,
        ConfirmDialogModule,
        MessagesModule,
        ToastModule,
        FormsModule,
        OverlayPanelModule,
        TabViewModule,
        MenuModule,
        AccordionModule,
        ChartModule,
        InputSwitchModule,
        SidebarModule,
        RadioButtonModule,
        TableModule,
        CarouselModule,
        SafePipeModule,
        NgxSpinnerModule,
        FileUploadModule,
        [NgxMaterialTimepickerModule],
        ToastrModule.forRoot({
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
        }),
        RatingModule.forRoot(),
        MsalModule.forRoot(new PublicClientApplication({
            auth: {
                clientId: CdsConfigData.credentials.clientId,
                authority: 'https://login.microsoftonline.com/' + CdsConfigData.credentials.tenantId,
                redirectUri: CdsConfigData.configuration.redirectUri,
                navigateToLoginRequestUrl: false
            },
            cache: {
                cacheLocation: BrowserCacheLocation.LocalStorage, //'localStorage',
                storeAuthStateInCookie: false,
            },
            system: {
                loggerOptions: {
                    loggerCallback: () => { },
                    piiLoggingEnabled: false
                }
            }
        }), {
            interactionType: InteractionType.Redirect, // MSAL Guard Configuration
            authRequest: {
                scopes: ["user.read"],
            },
        }, {
            interactionType: InteractionType.Redirect, // MSAL Interceptor Configuration
            protectedResourceMap: new Map([
                
          [CdsConfigData.resources.CDSAPI.resourceUri, [CdsConfigData.resources.CDSAPI.resourceScopes]],
                ['https://graph.microsoft.com/v1.0/me&#39;', ['user.read']]
            ])
        })], providers: [
            { provide: APP_BASE_HREF, useValue: '/' },
            { provide: 'APP_CONFIG_DATA', useValue: CdsConfigData },
            { provide: LocationStrategy, useClass: PathLocationStrategy },
            { provide: Globals, useValue: undefined },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: MsalInterceptor,
                multi: true
            },
            { provide: CSP_NONCE, useValue: 'abc123' },
            MsalService,
            MsalGuard,
            MsalBroadcastService,
            MessageService,
            DatePipe,
            provideHttpClient(withInterceptorsFromDi()),
        ]
})
export class AppModule { }

